var _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluegradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 78,
    viewBox: "0 0 330 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 66,
    r: 7,
    fill: "url(#paint0_radial_306_904)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 52,
    r: 7,
    fill: "url(#paint1_radial_306_904)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 13,
    r: 7,
    fill: "url(#paint2_radial_306_904)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 7,
    r: 7,
    fill: "url(#paint3_radial_306_904)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 45,
    r: 7,
    fill: "url(#paint4_radial_306_904)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 41,
    rx: 14,
    ry: 13,
    fill: "url(#paint5_radial_306_904)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 203,
    cy: 65,
    rx: 14,
    ry: 13,
    fill: "url(#paint6_radial_306_904)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 178,
    cy: 20,
    rx: 14,
    ry: 13,
    fill: "url(#paint7_radial_306_904)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316,
    cy: 52,
    rx: 14,
    ry: 13,
    fill: "url(#paint8_radial_306_904)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 20,
    rx: 14,
    ry: 13,
    fill: "url(#paint9_radial_306_904)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22 66) rotate(90) scale(7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132 52) rotate(90) scale(7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297 13) rotate(90) scale(7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111 7) rotate(90) scale(7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 45) rotate(90) scale(7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70 41) rotate(90) scale(13 14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203 65) rotate(90) scale(13 14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178 20) rotate(90) scale(13 14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(316 52) rotate(90) scale(13 14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_306_904",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 20) rotate(90) scale(13 14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748EDB",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluegradient);
export default __webpack_public_path__ + "static/media/bluegradient.273f9795ccce6fc29d6dbdd4235fb132.svg";
export { ForwardRef as ReactComponent };